import { render, staticRenderFns } from "./Fotogalerie.vue?vue&type=template&id=0591d57a&"
import script from "./Fotogalerie.vue?vue&type=script&lang=js&"
export * from "./Fotogalerie.vue?vue&type=script&lang=js&"
import style0 from "./Fotogalerie.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
